<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Planos</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="actions">
        <div class="create">
          <button mat-raised-button color="accent" type="button" (click)="openCreatePlanModal()">
            Criar Novo Plano
          </button>
        </div>
        <div class="filters">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Pesquisar</mat-label>
            <input matInput placeholder="Pesquisar planos..." [(ngModel)]="search" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" (click)="onSearch()" [disabled]="isFilterApplied">
            Pesquisar
          </button>
          <button *ngIf="isFilterApplied" mat-raised-button class="clear-button" type="button" (click)="clearFilters()">
            Limpar Filtros
          </button>
        </div>
      </div>
      
      <div class="table-container">
        <table class="plans-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Preço</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of plans" [ngClass]="{'inactive-plan': plan.status === 'inactive'}">
              <td>{{ plan.name }}</td>
              <td>{{ plan.price | currency }}</td>
              <td>{{ plan.status === 'active' ? 'Ativo' : 'Inativo' }}</td>
              <td>
                <button *ngIf="plan.status === 'active'" mat-icon-button class="action-button edit" (click)="openEditPlanModal(plan)" matTooltip="Editar Nome do Plano">
                  <fa-icon [icon]="'pencil-alt'" class="icon edit"></fa-icon>
                </button>
                <button *ngIf="plan.status === 'active'" mat-icon-button class="action-button inactivate" (click)="inactivatePlan(plan)" matTooltip="Inativar Plano">
                  <fa-icon [icon]="'trash-alt'" class="icon inactivate"></fa-icon>
                </button>
                <button mat-icon-button class="action-button access" (click)="accessPlan(plan)" matTooltip="Acessar Preços do Plano">
                  <fa-icon [icon]="'external-link-square-alt'" class="icon access"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="pagination">
        <button *ngIf="page > 1" mat-stroked-button type="button" (click)="changePage(page - 1)">
          Anterior
        </button>
        <span>Página {{ page }}</span>
        <button mat-stroked-button type="button" (click)="changePage(page + 1)" [disabled]="plans.length < 20">
          Próxima
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
